var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import React from 'react';
import styled, { css } from 'styled-components';
import { classNames } from '@shapeable/utils';
var cls = classNames('entity-default-layout');
import { breakpoints, theme } from '@shapeable/theme';
export var EntityDefaultLayoutDefaultProps = {};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    padding: ", ";\n\n    code {\n      font-family: ", ";\n      border-radius: 2px;\n      background: ", ";\n      border: 1px solid ", ";\n    }\n\n    pre {\n      background: ", ";\n      border: 1px solid ", ";\n      padding: ", ";\n      font-family: ", "\n    }\n  "], ["\n    padding: ", ";\n\n    code {\n      font-family: ", ";\n      border-radius: 2px;\n      background: ", ";\n      border: 1px solid ", ";\n    }\n\n    pre {\n      background: ", ";\n      border: 1px solid ", ";\n      padding: ", ";\n      font-family: ", "\n    }\n  "])), theme.UNIT(6), theme.FONT('mono'), theme.COLOR('app-chrome'), theme.COLOR('line-mid'), theme.COLOR('app-chrome'), theme.COLOR('line-mid'), theme.UNIT(4), theme.FONT('mono'))
});
// -------- Components -------->
var My = {
  Container: styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles)
};
export var EntityDefaultLayout = function (props) {
  var className = props.className,
    entity = props.entity,
    entityTypeName = props.entityTypeName;
  return React.createElement(My.Container, {
    className: cls.name(className)
  }, React.createElement("p", null, "No component has been specified to render entities of type ", React.createElement("code", null, entityTypeName), "."), React.createElement("p", null, "Please provide a layout component via the ", React.createElement("code", null, "EntityLayoutsProvider")), React.createElement("pre", null, "<EntityLayoutsProvider value={{", entityTypeName, ": ", entityTypeName, "Layout }} />"));
};
EntityDefaultLayout.defaultProps = EntityDefaultLayoutDefaultProps;
EntityDefaultLayout.cls = cls;
export var createEntityDefaultLayout = function (entityTypeName) {
  return function (props) {
    return React.createElement(EntityDefaultLayout, __assign({}, props, {
      entityTypeName: entityTypeName
    }));
  };
};
var templateObject_1, templateObject_2;